export const iFramePostMessage = (message, target = 'preview') => {
  const frame = document.getElementById(target);
  if (frame) frame.contentWindow.postMessage(message, '*');
};

export const FPM = iFramePostMessage;
